import React from 'react';

const PoliticaPrivacidad: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6">Política de Privacidad</h1>
        <p className="text-sm text-gray-500 mb-8">Última actualización: 30 de octubre de 2025</p>

        <div className="space-y-8 text-gray-800">
          <section>
            <h2 className="text-xl font-bold mb-3">1. Quiénes somos</h2>
            <p>
              Princonser Kids ("nosotros") desarrolla experiencias educativas digitales y físicas orientadas a niños y familias.
              Esta política explica cómo tratamos tus datos personales cuando usas nuestro sitio y te registras en la lista de espera de Kickstarter.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">2. Datos que recopilamos</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Datos de contacto: correo electrónico que nos proporcionas para la lista de espera o formularios de contacto.
              </li>
              <li>
                Datos técnicos: dirección IP, identificadores de dispositivo, páginas visitadas y eventos de interacción (por ejemplo, clics en CTAs), mediante herramientas de analítica.
              </li>
              <li>
                Preferencias de comunicación: tu consentimiento para recibir notificaciones y tu idioma/región cuando lo compartes.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">3. Finalidades y base legal</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Notificarte sobre la apertura de la campaña en Kickstarter y enviarte acceso preferente (consentimiento del usuario).
              </li>
              <li>
                Medir el uso del sitio para mejorar la experiencia (interés legítimo en analítica y rendimiento, con opciones de opt‑out cuando corresponda).
              </li>
              <li>
                Cumplir requerimientos legales y de seguridad de la información (obligación legal/interés legítimo).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">4. Conservación</h2>
            <p>
              Conservamos tus datos el tiempo necesario para las finalidades descritas o hasta que retires tu consentimiento. Eliminamos o anonimizamos la información cuando deja de ser necesaria.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">5. Destinatarios y transferencias</h2>
            <p>
              Podemos usar proveedores de servicios (por ejemplo, herramientas de analítica, envío de correos) que actúan como encargados de tratamiento y con quienes firmamos acuerdos de protección de datos. Algunos pueden estar fuera de tu país; en ese caso aplicamos salvaguardas adecuadas (cláusulas contractuales tipo u otros mecanismos reconocidos).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">6. Derechos de los usuarios</h2>
            <p>
              Tienes derecho a acceder, rectificar, eliminar, oponerte y solicitar la limitación del tratamiento de tus datos, así como a la portabilidad cuando proceda. Puedes retirar tu consentimiento en cualquier momento sin afectar la licitud del tratamiento previo.
            </p>
            <p className="mt-2">
              Para ejercer tus derechos, contáctanos en <a href="mailto:privacy@princonserkids.com" className="text-cyan-600 underline">privacy@princonserkids.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">7. Menores de edad</h2>
            <p>
              Priorizamos la privacidad infantil. Los formularios públicos están orientados a padres o tutores. En funciones que involucren a menores, aplicamos minimización de datos y controles parentales. El ranking/funciones sociales son opt‑in y controladas por el adulto.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">8. Seguridad</h2>
            <p>
              Implementamos medidas técnicas y organizativas razonables para proteger los datos contra acceso, uso o divulgación no autorizados. Ningún sistema es 100% seguro; te recomendamos buenas prácticas (contraseñas robustas, cuidado con phishing).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">9. Cookies y analítica</h2>
            <p>
              Utilizamos cookies y tecnologías similares para analizar el uso del sitio y mejorar el servicio. Puedes gestionar tus preferencias desde la configuración de tu navegador o herramientas de consentimiento cuando estén disponibles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">10. Cambios a esta política</h2>
            <p>
              Podemos actualizar esta política ocasionalmente. Publicaremos la versión vigente en esta página con la fecha de última actualización.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">11. Contacto</h2>
            <p>
              Si tienes preguntas, escríbenos a <a href="mailto:privacy@princonserkids.com" className="text-cyan-600 underline">privacy@princonserkids.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;


